module.exports = __webpack_public_path__ + "img/shop-map.1635d0b5.jpg";